mutation UpdateLink($id: ID!, $input: UpdateLinkInput!) {
  updateLink(id: $id, input: $input) {
    id
    title
    url
    slug
    linkType
    href
    targetType
    targetId
    targetTitle
    utmSource
    utmMedium
    utmCampaign
    utmTerm
    utmContent
    url
    targetUrl
    reward {
      type
      percent
      fixedAmount
      fixedCurrency
    }
    createdAt
    updatedAt
  }
}
